export default __webpack_public_path__ + "media/images/big_logo_v4-b4b456cd353bff57c2d518bbe78ceb84.png";